module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_mobile_2990062d2719a8592676d686ac312e58.png";